import { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import EventFilter from './EventFilter';
import "@fontsource/rubik";
import useFilter from '../hooks/useFilter';


const CustomPopoverFilter = (props) => {

    const {listType} = props;
    const {eventCountByStatus, statusCheckHandler} = useFilter(listType)
   const [anchorEl, setAnchorEl] = useState(null);
   //   const [selectedSortbyValue, setSelectedSortbyValue] = useState(null);
   
     const handleClick = (event) => {
       setAnchorEl(event.currentTarget)
     }
   
     const handleClose = () => {
       setAnchorEl(null);
     }

    return (
      <>
        <Box onClick={handleClick}  sx={{display:'flex', alignItems:'center', justifyContent:"center"}}>
             <Typography sx={{fontSize:{xs:'8px',sm:'8px',md:'10px',lg:'10px',xl:'13px'}, fontWeight:600, fontFamily:'Rubik'}}>Event Type</Typography>
              <IconButton>
                  <KeyboardArrowDownOutlinedIcon sx={{color:'black',fontSize:{xs:'8px',sm:'8px',md:'10px',lg:'10px',xl:'13px'}}}/>
              </IconButton>  
          </Box>

        <Menu  anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} sx={{fontSize:{xl:''}}}>
          
            <MenuItem 
             // key={option.value} 
              anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
              }}
              transformOrigin={{
                 vertical: "bottom",
                horizontal: 'right',
               }}
               
              
              >
             <EventFilter listType= {listType} eventCounter = {eventCountByStatus} checkStatus = {statusCheckHandler}  />
            </MenuItem>
          
        </Menu>
      </>
    );
  };


 

export default CustomPopoverFilter